import { Tabs, Spin, Alert } from 'antd';
import React, { useState } from 'react';
import BasicLayout from '../../components/layout/BasicLayout';
import { Chart } from './tabs/Chart/Chart';
import { useTranslation } from 'react-i18next';
import { ReportBuilder } from './tabs/ReportBuilder';
import { ReportSummary } from './tabs/ReportSummary';
import { ReportStatus } from './tabs/ReportStatus';
import { ListService } from './tabs/ListService';
import { ListEvent } from './tabs/ListEvent';
import { usePageAccess } from '../../hooks/usePageAccess';
import { API_ROOT } from '../../config';
const { TabPane } = Tabs;

export const GovernmentServiceEducation = () => {
  const [isAction] = useState(false);
  const { t } = useTranslation();
  const { checking, isAccessDenied } = usePageAccess(`${API_ROOT}/edu-service-registry`);

  const ListTabs = () => (
    <Tabs defaultActiveKey="listService">
      <TabPane tab={t('gosServiceList.listService')} key="listService">
        <ListService />
      </TabPane>
      <TabPane tab={t('gosServiceList.listEvent')} key="listEvent">
        <ListEvent />
      </TabPane>
      <TabPane tab={t('gosServiceList.charts')} key="reportList">
        <Chart isAction={isAction} />
      </TabPane>
      <TabPane tab={t('gosServiceList.createChart')} key="reportBuilder">
        <ReportBuilder />
      </TabPane>
      <TabPane tab={t('gosServiceList.summaryChart')} key="reportSummary">
        <ReportSummary />
      </TabPane>
      <TabPane tab={t('gosServiceList.chartStatus')} key="reportStatus">
        <ReportStatus />
      </TabPane>
    </Tabs>
  );

  const renderContent = () => {
    if (checking) {
      return (
        <div style={{ textAlign: 'center', padding: '64px 0' }}>
          <Spin tip={t('intersections.loadingPleaseWait') + '...'} />
        </div>
      );
    }

    if (isAccessDenied) {
      return (
        <Alert
          type="error"
          showIcon
          message={t('error.doNotHaveAccessToViewThisModule')}
        />
      );
    }

    return <ListTabs />;
  };

  return <BasicLayout>{renderContent()}</BasicLayout>;
};
